import { useBeforeUnload, useLocation, useNavigate } from "react-router-dom";
import FormHeader from "../../components/dms_common/FormHeader";
import CustomAccordian from "../../components/dms_common/CustomAccordian";
import { useCallback, useEffect, useRef, useState } from "react";
import { getMetaData1, getViewOrderConfig, metaData2, setAndGetViewOrderEditTableHeader } from "../viewOrder/ViewOrderConfig";
import { getConfigData } from "../../services/configurationService";
import BorderHeading from "../../components/heading/BorderHeading";
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import { viewManageOrderRowsData } from "../viewOrder/ViewOrderType";
import { useDispatch, useSelector } from "react-redux";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { getOrderTotalRowData } from "../viewOrder/ViewOrderUtils";
import { createScrollHandler, handleScroll, safeStringify, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { getDataFromLocalDb } from "../../services/dbService";
import { checkIsEWayBilledApi } from "../../services/manageOrderService";
import "./reviewInvoice.css"
import { ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { Loader } from "../../components/loader/Loader";
import React from "react";
import { setCollectionData, setCollectionDisableEditing, setUpdatedInvoiceDetails } from "../../stateManagement/actions/collectionActions";
import { CollectionsState } from "../../stateManagement/reducers/collectionReducer";
import NewDiscountModal from "../claimsNew/modals/NewDiscountModal";
import { approveSalesReturnWithoutInvoice, clearBatchDetailsInDb, editSalesReturn, newEditSalesReturn } from "../SalesReturn/SalesReturnService";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import { approveSalesReturnWithInvoice } from "../SalesReturn/SalesReturnService";

const ReviewInvoice = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reqBody = location?.state?.reqBody;
    const invoiceDetails = location?.state?.invoiceDetails;
    const isReturnInvoice = location?.state?.isReturnInvoice;
    const unsaleableData = location?.state?.unsaleableData;
    const submission = location?.state?.submission;
    // const [TableHeaders, SetViewOrderEditTableHeader] = useState<Record<string, string>>({});
    const [allData, setAllData] = useState<viewManageOrderRowsData[]>([]);
    const [filteredData, setfilteredData] = useState<viewManageOrderRowsData[]>([]);
    const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
    const [isScrolling, setIsScrolling] = useState(false);
    const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
    const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [columns, setColumns] = useState<any>([]);
    const [accordianData, setAccordianData] = useState<any>({});
    const [loaded,setLoaded] = useState(false);
    const [scrollTop, setScrollTop] = useState<number>(0); 
    const scrollRef = useRef<HTMLDivElement>(null);
    const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
    const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);
    
    const collectiondata = useSelector((state: {collections:CollectionsState}) => state?.collections);
    useBeforeUnload(
        React.useCallback(() => {
            localStorage.deliveryCollectionData = JSON.stringify(collectiondata);
        }, [collectiondata])
      );
    
      useEffect(()=>{
        if(localStorage.deliveryCollectionData){
          setCollectionData(JSON.parse(localStorage.deliveryCollectionData));
        }
        delete localStorage.deliveryCollectionData;
        setLoaded(true);
      },[]);


    const fetchData = async () => {
        const statusConfig = await getConfigData("dms_configuration", "invoiceStages")
        setOrderTrackingConfig(statusConfig[0]?.configValue ?? []);
        const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
        const tableData = setAndGetViewOrderEditTableHeader(ConfigDictionary);
        // SetViewOrderEditTableHeader(tableData);
        const totalData = getOrderTotalRowData(invoiceDetails, tableData, ConfigDictionary);
        setTotalFooterValue(totalData);
        const viewOrderConfig = getViewOrderConfig(
            handlePromotionModalVisibility,
            true,
            tableData,
            false,
            false   
        );
        const dataArr: viewManageOrderRowsData[] = [];
          let taxAmount: number = 0;
          let totalDiscountValue: number = 0;
          let totalCouponValue: number = 0;
          let totalAdditionalDistributorDiscount: number = 0;
        const dbResult = await getDataFromLocalDb("Product");
        const products: any = dbResult?.data?.[0]?.data ?? {};
        if(unsaleableData)    {
            unsaleableData.forEach((item:any)=>{item.initialPieceQuantity = item.pieceQuantity})
            invoiceDetails.salesDetails.push(...unsaleableData);
        }
        invoiceDetails.orderDetails = invoiceDetails?.salesDetails;
        invoiceDetails?.salesDetails?.forEach((item: any, index: any) => {
            const {
              batchCode,
              batchId,
              price,
              casePrice,
              otherUnitPrice,
              initialPieceQuantity,
              caseQuantity,
              otherUnitQuantity,
              productInfo,
              creationTime,
              netAmount,
              initialAmount,
              extendedAttributes,
              type,
              discountValue,
              initialNormalizedQuantity,
              couponValue
            } = item;
            const discount = truncateToTwoDecimals((discountValue ?? 0) + (couponValue ?? 0));
            const finalAmount = netAmount ? truncateToTwoDecimals(netAmount) : "0";
            const actualAmount = initialAmount ? truncateToTwoDecimals(initialAmount) : "0";
            const skuDescription = productInfo?.skuDescription ?? "-";
            const formattedPrice = truncateToTwoDecimals(price ?? 0);
            const formattedCasePrice = truncateToTwoDecimals(casePrice ?? 0);
            const formattedOtherPrice = truncateToTwoDecimals(otherUnitPrice ?? 0);
            const id = `row-${index + 1}`;
    
            const freeItem: boolean = type === "freeItem";
    
            const taxInfo = extendedAttributes?.taxInfo;
            if(!freeItem) {
              taxInfo?.forEach((taxType: any) => (taxAmount += taxType?.taxAmount || 0));
            }
        totalDiscountValue += discountValue ?? 0;
        totalCouponValue += couponValue ?? 0;
        totalAdditionalDistributorDiscount += item.additionalDistributorDiscount ?? 0;
            const skuDiscountInfo = [
              { discountType: "Coupon", discountAmount: couponValue ?? 0 },
             { discountType: "Scheme", discountAmount: discountValue ?? 0 },
            ]

            const status = invoiceDetails?.status?.toLocaleUpperCase();
    
            dataArr.push({
              id,
              batchCode,
              batchId,
              skuDescription,
              caseQuantity,
              pieceQuantity:initialPieceQuantity,
              otherUnitQuantity,
              casePrice: formattedCasePrice,
              price: formattedPrice,
              otherUnitPrice: formattedOtherPrice,
              actualAmount,
              discount,
              finalAmount,
              creationTime,
              availableStock:{},
              taxInfo,
              status,
              uom: "all",
              initialCaseQuantity: caseQuantity,
              initialOtherUnitQuantity: otherUnitQuantity,
              initialPieceQuantity: initialPieceQuantity,
              freeItem,
              caseToPieceQty: products[batchCode]?.caseToPieceQuantity ?? extendedAttributes?.["caseToPiece"] ?? 99999,
              otherToPieceQty: products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
              initialNormalizedQuantity,
              skuDiscountInfo,
              actualCaseQuantity: caseQuantity,
              actualPieceQuantity: initialPieceQuantity,
              actualOtherUnitQuantity: otherUnitQuantity
            });
          });
        
        const eInvoiced: boolean =
        invoiceDetails?.status?.toLowerCase() === "invoiced" &&
        (invoiceDetails?.eInvoice === "true" || invoiceDetails?.extendedAttributes?.IRNDtls);
        let eWayBilled: boolean = false;
        if(eInvoiced) {
        const response = await checkIsEWayBilledApi(invoiceDetails?.invoiceNumber);
        eWayBilled = response?.data?.success === true;
        }
        setAccordianData({ ...invoiceDetails, taxAmount, discountValue: truncateToTwoDecimals(totalDiscountValue),
        couponValue: truncateToTwoDecimals(totalCouponValue), additionalDistributorDiscount: truncateToTwoDecimals(totalAdditionalDistributorDiscount), cancelledInvoice:false, eInvoiced, eWayBilled});
        setAllData(dataArr);
        setfilteredData(dataArr);
        setColumns(viewOrderConfig?.columns);
    }

    useEffect(() => {
        if(!loaded){
            return;
        }
        fetchData();
    }, [loaded])

    const handlePromotionModalVisibility = (paramRow: any) => {
        setSelectedSkuCode(paramRow?.batchCode);
        dispatch(setDiscountModalState(true));
    };

    

    const handleSearchValueChange = useCallback((searchStr:string) => {
        searchStr = searchStr.toLowerCase();
        if(searchStr){
            setfilteredData(allData.filter(data=> data.skuDescription.toLowerCase().includes(searchStr) || data.batchCode.toLowerCase().includes(searchStr)));
        }else{
            setfilteredData(allData);
        }
    },[allData]);

    const onCustomAccordionToggle = (isExpanded: boolean) => {
        setIsScrolling(!isExpanded);
    };

    const deliverInvoice = async() => {
        try{
            const response = await ChannelkartNetworkPut("/v1/loadoutOrchestrator",reqBody);
            if(response.status==200){
                openPopup("Success","Invoice partially delivered successfully",()=>{
                    setUpdatedInvoiceDetails({
                        taxAmount:accordianData.taxAmount,
                        discountAmount:accordianData.discountValue,
                        amount:accordianData.totalAmount,
                        totalAmount:accordianData.totalAmount,
                        finalAmount:accordianData.netAmount
                    });

                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-1);
                    setCollectionDisableEditing(true);
                });
            }else{
                openPopup("Error","Unable to deliver invoice, please try again");
            }
        }catch(e){
            const errorApiResponse = (e as any)?.response || null;
            await sendSlackAlert(
                SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
                "Loadout: Failed to partially deliver invoice while deliverInvoice",
                `Loadout: Failed to partially deliver invoice while deliverInvoice in ReviewInvoice.tsx`,
                safeStringify({ requestBody: reqBody, error: e, apiResponse: errorApiResponse })
              );
            openPopup("Error","Unable to deliver invoice, please try again");
        }
    }

    const createReturn = async() => {
        try{
            const updatedReqBody = {
                ...reqBody,
                extendedAttributes: {
                    ...reqBody.extendedAttributes,
                    isNewSchemes: true
                },
                salesDetails: reqBody.salesDetails?.map((detail: any) => ({
                    ...detail,
                    extendedAttributes: detail?.extendedAttributes || {}
                }))
            };
            const apiEndpoint = reqBody.referenceNumber || reqBody.invoiceNumber ? "/v1/sales/createReturn" : "/v1/sales/createSalesReturnWORefNum";
            const response = await ChannelkartNetworkPost(apiEndpoint,updatedReqBody);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-3);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }

    const approveReturnWithInvoice = async() => {
        try{
            const invoiceDataWithReturnNumber = {
                ...invoiceDetails,
                returnNumber: reqBody?.invoiceNumber 
            };
            const response = await approveSalesReturnWithInvoice(invoiceDataWithReturnNumber);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-2);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }

    const partialApproveReturnWithInvoice = async() => {
        try{
            const response = await ChannelkartNetworkPut("/v1/sales/editReturn", reqBody);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-2);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }

    const approveReturn = async() => {
        try{
            const response = await approveSalesReturnWithoutInvoice(reqBody);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-2);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }

    const newPartialApproveReturn = async() => {
        try{
            const response = await newEditSalesReturn(reqBody);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-2);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }

    const partialApproveReturn = async() => {
        try{
            const response = await editSalesReturn(reqBody);
            if(response.status==200){
                openPopup("Success","Return saved successfully",()=>{
                    clearBatchDetailsInDb();
                    localStorage.setItem("ristrictForwardNavigation","true");
                    navigate(-2);
                });
            }else{
                openPopup("Error","Unable to save return, please try again");
            }
        }catch(e){
            openPopup("Error","Unable to save return, please try again");
        }
    }
    

    const handleSubmit = async() => {
        const isWithInvoice = !!reqBody?.referenceNumber;
         if (isReturnInvoice) {
        const invalidLine = invoiceDetails?.salesDetails?.find((detail: any) => {
            const initialAmount   = Number(detail.initialAmount ?? 0);
            const totalDiscount   = Number(detail.totalDiscountValue ?? 0);
            return initialAmount - totalDiscount < 0;
        });

        if (invalidLine) {
            const skuInfo =
                invalidLine.batchCode

            openPopup(
                "Error",
                skuInfo
                    ? `Return cannot be submitted because discount on SKU ${skuInfo} is more than its amount.`
                    : "Return cannot be submitted because discount on one or more items is more than its amount."
            );
            return;
        }
    }
       
    
      setIsSubmitting(true);
        switch(submission){
            case "createReturn":
                await createReturn();
                break;
            case "approveReturn":
                if(isWithInvoice){
                    await approveReturnWithInvoice();
                }else{
                await approveReturn();
                }
                break;

            case "partialApproveReturn":
                if (isWithInvoice) {
                    await partialApproveReturnWithInvoice(); 
                } else {
                    await partialApproveReturn(); 
                }
                break;
            case "newPartialApproveReturn":
                await newPartialApproveReturn();
                break;
            default:
                await deliverInvoice();
                break;
        }
        
        setIsSubmitting(false);
    }

      useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (document.querySelector('[role="dialog"]')) {
                console.log("Ignoring shortcut due to open dialog");
                return;
            }

            const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
            const isCtrlOrCmd = isMac ? event.metaKey : event.ctrlKey;

            if (isCtrlOrCmd && event.key.toLowerCase() === "a") {
                event.preventDefault(); // Prevent browser's default select all

                if (isSubmitting) {
                    console.log("Ignoring shortcut: submission in progress");
                    return;
                }

                console.log("Executing handleSubmit for Ctrl + A");
                handleSubmit();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isSubmitting, handleSubmit]);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handler = createScrollHandler(
            scrollRef,
            isScrolling,
            setAllowTableScroll,
            setDontContainerScroll
        );

        el.addEventListener("wheel", handler);

        return () => {
            el.removeEventListener("wheel", handler);
        };
    }, [isScrolling, dontAllowContainerScroll]);

    return (
        <div className="review-invoice-container" onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}>
            <NewDiscountModal skuData={invoiceDetails} selectedSkuCode={selectedSkuCode} />
            <FormHeader
                parentLabel={isReturnInvoice ? "Return Details" : "Invoice Details"} 
                label={"Review"}
                goBackToParent={() => { navigate(-1) }}
                searchFunction={handleSearchValueChange}
            />
            <div ref={scrollRef} style={{
            gap: "14px",
            overflow: (dontAllowContainerScroll) ? "hidden" : "scroll",
            height: "100%",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE 10+
            }}
            >
                <CustomAccordian
                    expanded={!isScrolling}
                    onCustomAccordionToggle={onCustomAccordionToggle}
                    isSecondHalf={true}
                    metaData1={getMetaData1()}
                    data1={accordianData}
                    metaData2={metaData2}
                    data2={accordianData}
                    header={`${isReturnInvoice ? "Summary" :("Invoice No. "+ invoiceDetails?.invoiceSerialNumber)}`}
                    label1={`${isReturnInvoice ? "Return" : "Invoice"} Summary`}
                    label2="Outlet Info"
                    statusConfig={isReturnInvoice ? null : orderTrackingConfig }
                    status={invoiceDetails?.status}
                    metaData1ChunkSize={4}
                />
                <div style={{height: "100%", position: "sticky", top: "0"}}>
                    <div className="view_order_details_vo">
                        <div className="review-invoice-heading">
                            <BorderHeading>
                                {isReturnInvoice ? "Return Details" : "Invoice Details"} 
                            </BorderHeading>
                        </div>
                        <CustomTablewithTotalInfo
                            data={filteredData}
                            columns={columns}
                            totals={totalFooterValue}
                            headerBackgroundColor="#F0FBFF"
                            isEditing={false}
                            children={<div className="review-invoice-footer">
                                    {isSubmitting ? <Loader size="sm" style={{marginRight:"3rem"}}/>
                                    : <button
                                        className={`submit-button-delivery`}
                                        style={{width:"125px"}}
                                        onClick={handleSubmit}
                                    >
                                        <span className="submit-button-delivery-text">
                                        SUBMIT
                                        </span>
                                    </button>}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>

    );
}

export default ReviewInvoice;